import React from 'react'
import "./PaymentStrategy.css";
import servBnr1 from "../../../assets/imgs/services/servBnr1.jpg";
import psmbnr from "../../../assets/imgs/services/psmbnr.jpg";
import growth from "../../../assets/imgs/growth.png";
import security from "../../../assets/imgs/security.png";
import pricing from "../../../assets/imgs/pricing.png";
import cashfree from "../../../assets/imgs/partners/cashfree.png";
import cfcs from "../../../assets/imgs/partners/cfcs.svg";
import easebuzz from "../../../assets/imgs/partners/easebuzz.svg";
import phonepe from "../../../assets/imgs/partners/phonepe.png";
import zaakpay from "../../../assets/imgs/partners//zaakpay.png";
import transactions from "../../../assets/imgs/transactions.png";
import ReadyToBusiness from '../../ReadyToBusiness/ReadyToBusiness';
import { Button } from "@mui/material";
import { Helmet } from "@dr.pogodin/react-helmet";
import PropTypes from "prop-types";


function PaymentStrategy({open, openContactForm}) {
    const handleWhatsApp = () => {
    window.open("https://wa.me/919876543210", "_blank"); 
  };
  return (
<div className='serpMn'>
   <Helmet>
        <title>Payment Gateway |  PAYTECH ADVISOR</title>
      </Helmet>
  <div className="psBnr">
        <div className="maxW">
            <div className="psBnrLft">
                <div className='psblfCon'>
                    <h1>Payment Gateway</h1>
                    <p>Precision Payments. Strategic Impact.</p>
                     <div className='serDtBTns'>
                        <Button variant="contained" onClick={openContactForm}>
        Enquire Now
      </Button>
                       {/* <Link to="/contact" className="psbtnLink">Contact Us</Link> */}
                    </div>
                </div>
            </div>
        </div>
        <div className="psBnrRyt">
          <img src={servBnr1} alt="servBnr1" />
        </div>
  </div>
  <div className='hdPaWrp'>
    <div className="maxW">
      <h2>At Paytech Advisors, we go beyond selling</h2>
      <p> we partner with you to craft payment strategies that truly work. Our approach begins with a deep understanding of your business model, operational challenges, and growth aspirations. Based on these insights, we design and recommend secure, reliable, and cost-effective payment solutions that integrate seamlessly into your operations.</p>
      <p>We help businesses identify and partner with the best Payment Gateway provider by assessing their unique needs, industry requirements, and growth goals.</p>
     <h2>Our consultancy ensures you select a solution that offers :</h2>
     <div className='hpliWrp'>
        <div>
           <img src={transactions} alt="transaction-img" />
            <h5> Seamless transactions</h5>
        </div>
       <div>
         <img src={security} alt="security-img" />
           <h5>Robust security</h5>
       </div>

      <div>
        <img src={pricing} alt="pricing-img" />
          <h5>Competitive pricing</h5>
       </div>
        <div>
          <img src={growth} alt="growth-img" />
           <h5>Scalability for growth</h5>
        </div>
   </div>
     <p>This enables you to accept payments effortlessly while expanding your reach.</p>
     <p>As strategic partners with leading PA–PGs, we enable a <strong>Multi-PG</strong> solutioning model for your business. This approach reduces dependency on a single service provider, ensuring greater flexibility, reliability, and negotiating power.</p>
     <p>At <strong>Paytech Advisors</strong>, we don’t just push products <strong>— we serve and solve </strong>by offering a variety of options tailored to your current and future business needs.</p>
  
    </div>
  </div>

  <div className="recPay">
    <div className="maxW">
      <div className="recpMn">
        <h2> Recurring payments </h2>
        <p>For businesses with <strong>repeat billing cycles</strong>, recurring payments simplify collections and improve customer convenience. Whether it’s <strong>premium collections, EMIs, loan repayments, tuition fees, subscriptions, memberships, utilities, or essentials</strong> like groceries, milk, or water, we help you enable frictionless auto-debit solutions that build reliability and trust. </p>
       <h5>Key Industries Served </h5>
       <p>Insurance, Lending,  Education,  Coaching,  SaaS,  Digital Services,  Healthcare,  Wellness,  Media,  OTT,  Utilities, Housing,  Quick Commerce / Groceries</p>
      <h5>Recurring Payment Options :</h5>
      <ul>
        <li>	<strong>UPI AutoPay</strong> – Auto-debit via UPI mandates</li>
         <li><strong>eNACH</strong> – Automated bank account debits</li>
          <li><strong>Standing Instructions (SI) on Cards</strong> – Recurring payments via credit/debit cards</li>
      </ul>
      <p>At Paytech Advisors, we ensure your business is equipped with the <strong>right recurring payment model</strong> to reduce drop-offs, improve cash flow, and create  <strong> a seamless experience for your customers</strong>.</p>
      </div>
    </div>
  </div>

  <div className="ptmthd">
    <div className="maxW">
    <h2> Our Payment Gateway Advisory include both API & Dashboard integration for the following products</h2>
    <div className="ptmthMn">
      <div className='mths mthC1'>
        <h4>Merchant QR: Static & Dynamic </h4>
        <p>Most reliable and cost-effective QR payment platforms, enabling secure & instant collections anytime, anywhere. </p>
      </div>
     <div className='mths mthC2'>
      <h4>Payment Links</h4>
      <p> Implement easy-to-use payment link solutions for faster collections via SMS, email, or social channels with secure requests.</p>
      </div>
     <div className='mths mthC3'>
       <h4>Pay-in & Payout Solutions</h4>
       <p>Access robust platforms to streamline both incoming payments and outgoing disbursements with unmatched speed, accuracy, and transparency.</p>
      </div>
       <div className='mths mthC4'>
       <h4>EPOS & POS Solutions</h4>
       <p> Integrate smart terminals for seamless payment acceptance with billing, analytics, and inventory management to boost business efficiency.</p>
      </div>
    </div>
    </div>
  </div>
  <div className='psBnrWrp'>
   <div className="maxW">
    <img src={psmbnr} alt="psmbnr-img" />
  <p>
    By addressing pain points and eliminating inefficiencies, we empower your business to unlock new opportunities, enhance customer experiences, and strengthen revenue streams. With Paytech Advisors, you gain more than just a payment solution — you gain a strategic advantage.
  </p>
 
   </div>
  </div>
  <div className='prtNrs'>
<div className="maxW">
<div className="prtsMn">
  <h2>Strategic partners for Growth and Excellence</h2>
  <div className='logoWrp'>
    <img src={zaakpay} alt="zaakpay-img" />
       <img src={phonepe} alt="phonepe-img" />
          <img src={easebuzz} alt="easebuzz-img" />
             <img src={cfcs} alt="cfcs-img" />
                <img src={cashfree} alt="cashfree-img" />
  </div>
</div>
</div>
  </div>
  <div>
    <ReadyToBusiness />
  </div>
</div>

  )
}
PaymentStrategy.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool,
};

PaymentStrategy.defaultProps = {
  open: false,
  openContactForm: false,
};
export default PaymentStrategy